import { Page, Preloader } from 'konsta/react';
import type { I18nKey } from '@harmony/shared';
import { useT } from '../i18n';
import { LogoMark } from './Logo';

export function CenterMessage({ textKey, loading }: { textKey: I18nKey; loading?: boolean }) {
  const t = useT();
  return (
    <Page className="flex flex-col items-center justify-center gap-4 px-8 text-center">
      <LogoMark size={72} />
      {loading && <Preloader />}
      <p className="text-tg-hint">{t(textKey)}</p>
    </Page>
  );
}
